module.exports = __webpack_public_path__ + "static/media/ProximaNova-Black.a9d76c01.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova/ProximaNova-Black.woff
// module id = 220
// module chunks = 0